import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function MultioptionQuestionIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 16 16'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2 4C2 3.44772 2.44772 3 3 3H13C13.5523 3 14 3.44772 14 4V6.5C14 7.05229 13.5523 7.5 13 7.5H3C2.44772 7.5 2 7.05228 2 6.5V4ZM13 4H3V6.5H13V4ZM2 9.5C2 8.94772 2.44772 8.5 3 8.5H13C13.5523 8.5 14 8.94772 14 9.5V12C14 12.5523 13.5523 13 13 13H3C2.44772 13 2 12.5523 2 12V9.5ZM13 9.5H3V12H13V9.5Z'
        fill='#3E8FFA'
      />
    </SvgIcon>
  );
}
